export default __webpack_public_path__ + "static/media/neutral.4c748c3b.svg";